const ViewMode = Object.freeze({
  LIST: "list",
  CARD: "card",
});

export { ViewMode };
